
        var result = require("!!../../../../node_modules/css-loader/index.js!./ramastanheader.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/ramastanheader/ramastanheader.component.css
// module id = 57
// module chunks = 4